import React, { useEffect } from "react";
import ReactPlayer from "react-player";
import { Link } from "react-router-dom";
import sal from "sal.js";

import Slider from "../../components/slider/Slider";
import projects from "../../data/projects";

const Home = () => {
  useEffect(() => {
    sal({
      threshold: 1,
      once: true,
    });
  }, []);

  // Get the first 3 projects for featured works
  const featuredProjects = projects.slice(0, 3);

  return (
    <>
      <div
        className=""
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0, transition: { duration: 0.3 } }}
      >
        {/* Slider  */}
        <Slider />

        {/* Home About Section  */}
        <div className="section--spacing-x section--spacing-y grid grid-cols-1 lg:grid-cols-3 lg:gap-2 ">
          <div className="mr-10">
            <h2 className="heading--one mb-5 font-light text-secondary ">
              Building a legacy of excellence
            </h2>
          </div>

          <div
            className="col-span-2 "
            data-sal="slide-up"
            data-sal-delay="300"
            data-sal-duration="1200"
            data-sal-easing="easeInOutSine"
          >
            <p className="description--styles">
              BrownEarth Developments Ltd. Your premier partner in innovative
              building development solutions. With a steadfast commitment to
              excellence, creativity, and sustainability, we are at the
              forefront of shaping skylines and communities through our
              exceptional projects.At BrownEarth Developments Ltd. we believe
              that buildings are more than just structures; they are living
              spaces that should inspire, elevate, and transform lives. With a
              team of passionate architects, engineers, designers, and
              construction experts, we embark on each project as a unique
              journey, blending cutting-edge technology with timeless design
              principles.
            </p>
          </div>
        </div>

        {/***  Features Work Section  **/}
        <div className="section--spacing-x section--spacing-y">
          <h2 className="heading--one mb-6 font-light text-secondary md:mb-10 ">
            featured works
          </h2>

          {featuredProjects.map((project, index) => (
            <div
              key={project.slug}
              className={`grid grid-cols-1 gap-y-1 md:grid-cols-3 md:gap-2 ${
                index > 0 ? "my-10" : ""
              }`}
            >
              <div className="flex flex-col items-start justify-center bg-stone-200 p-4 lg:p-10 ">
                <Link to={`/project/${project.slug}`}>
                  <h4 className="sub--title">
                    {project.developer.toUpperCase()}
                  </h4>
                  <h2 className="project--title">
                    {project.title.toUpperCase()}
                  </h2>
                </Link>

                <h4 className="sub--title">{project.location.toUpperCase()}</h4>
              </div>

              {/* thumb  */}
              <div className="group relative col-span-2 cursor-pointer font-poiret">
                <img
                  className="aspect-21/9 object-cover"
                  src={project.thumb}
                  alt={project.title}
                />
                <div className="bg-blur absolute left-0 top-0 hidden h-0 w-full flex-col items-center justify-center border-b-2 opacity-0 backdrop-blur-md duration-500 group-hover:h-[50%] group-hover:opacity-100 dark:bg-slate-500 sm:flex">
                  <h2 className="project--title-btn">
                    {project.title.toUpperCase()}
                  </h2>
                  <Link
                    to={`/project/${project.slug}`}
                    className="mt-5 rounded-full bg-white px-8 py-3 duration-300 hover:bg-stone-300 dark:bg-slate-600 dark:text-slate-200 dark:hover:bg-slate-700 "
                  >
                    Project Details
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Video Section  */}
        <div className="aspect-video lg:mx-20">
          <ReactPlayer
            url="https://youtu.be/sJnr0l592PI"
            width="100%"
            height="80%"
            controls={true}
            muted={false}
          />
        </div>

        {/* Footprints Section  */}
        <div className="mb-32 grid grid-cols-1 gap-2 bg-neutral-300 md:grid-cols-3 ">
          <div className="section--spacing-x heading--one flex items-center py-6 font-bold uppercase tracking-wider text-secondary ">
            FOOTPRINTS
          </div>

          <div className=" md:col-span-2">
            <div className="relative h-[400px] overflow-hidden bg-gray-300 lg:h-[430px] xl:h-[580px] ">
              <iframe
                src="https://www.google.com.qa/maps/d/u/0/embed?mid=1vInsFJilsulIcidRH45aOFEZOAJ_qv8&ehbc=2E312F"
                width="100%"
                height="100%"
                className="absolute inset-0"
                frameBorder="0"
                title="map"
                marginHeight="0"
                marginWidth="0"
                scrolling="yes"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
